import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SnIconModule } from '@lib/ui/icon';

import { SnRadialSliderComponent } from './components/control';
import { SnRadialSliderFormField } from './components/field-type';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SnIconModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'radial',
          component: SnRadialSliderFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
  declarations: [SnRadialSliderComponent, SnRadialSliderFormField],
  exports: [SnRadialSliderComponent],
})
export class SnRadialSliderModule {}
